/**
 * @description bank account verification status
 */
export enum BankAccountVerificationStatus
{
  WaitingOnVerificationDeposits = 'WaitingOnVerificationDeposits',
  VerificationDepositsMade = 'VerificationDepositsMade',
  Verified = 'Verified',
  WaitingOnAdditionalUserInput = 'WaitingOnAdditionalUserInput',
  WaitingOnInstantReverification='WaitingOnInstantReverification'
}

export enum BankAccountAddAllowed
{
  MaxUnverifiedBankAccountsReached = 'MaxUnverifiedBankAccountsReached',
  MaxBankAccountsReached = 'MaxBankAccountsReached',
  Allowed = 'Allowed'
}



// WEBPACK FOOTER //
// ./src/model/types/bank-account-verification-status.ts